import React, {useMemo} from 'react'
import {AppBar, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import StageElement from './components/StageElement';
import GridBlock from 'components/GridBlock';
import {withRouter} from "react-router";
import RouterPath from "libs/RouterPath";
import {connect} from "react-redux";

const style = theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        top: 64,
        zIndex: 1099
    },
    gridItem: {
        flexGrow: 1
    },
    modification: {
        fontWeight: 400
    }
})

function ContractorStageBar(
    {
        contractor,
        classes,
        match,
        demandStagesList = [],
        demandHeader
    }) {
    const demandId = match.params.id;
    const stageId = match.params.stageId;
    const contractorDepartmentId = !contractor ? match.params.contractorDepartmentId : undefined;

    const createElement = (label, label2, onClick, current) => ({label, label2, onClick, current})

    const stageClick = (path) => {
        RouterPath.redirect(path);
    }


    const elements = useMemo(() => {

        const elements = demandStagesList.map(x => createElement(
            x.name,
            undefined,
            () => {
                if (contractor) {
                    if(demandHeader?.apiOffers) {
                        stageClick(RouterPath.createPath(RouterPath.ctrDemand.steps.CTR_DEMAND_ID_OFFER_STAGE_ID, {id: demandId, stageId: x.identity}))
                    } else {
                        window.location.href = demandHeader.oldPlatformRoundStatusUrl;
                    }

                } else {
                    stageClick(RouterPath.createPath(RouterPath.purchaserDemand.PURCHASER_DEMAND_ID_OFFER_CONTRACTOR_ID_STAGE_ID, {
                        id: demandId,
                        contractorDepartmentId,
                        stageId: x.identity
                    }))
                }
            },
            "" + x.identity === stageId))

        return elements;
        // eslint-disable-next-line
    }, [demandStagesList, stageId, contractorDepartmentId]);


    return (
        <AppBar
            id='stageBar'
            component='div'
            elevation={0}
            position='sticky'
            className={classes.root}
        >
            <GridBlock
                itemClassName={classes.gridItem}
            >
                {elements.map(({label, label2, onClick, current}, i) => {
                    return (
                        <StageElement
                            key={i}
                            current={current}
                            onClick={onClick}
                            thin
                        >
                            {label} {!!label2 && <span className={classes.modification}>({label2})</span>}
                        </StageElement>
                    )
                })}
            </GridBlock>
        </AppBar>
    )
}

ContractorStageBar.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    demandHeader: state.resources.demandHeader,
}), {})(withRouter(withStyles(style)(ContractorStageBar)));